import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import DateRangeComp from "../../common/DateRangeComp";
import "../../memberlist/components/MemberReport.css";
import * as actions from "../redux/ReportAction";
import { WinLoseDetails } from "./WinLoseDetails";
export const AgentDownlineReportList = () => {
  const intl = useIntl();
  const { auth } = useAuth();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const location = useLocation();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [returnFromDate, setReturnFromDate] = useState(
    new Date(location.state?.fromDate)
  );
  const [returnToDate, setReturnToDate] = useState(
    new Date(location.state?.toDate)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [currentAgent, setCurrentAgent] = useState("");
  const [currentMasterId, setCurrentMasterId] = useState("");
  const [detailQuery, setDetailQuery] = useState();
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const timeZone = "Asia/Kuala_Lumpur";
  const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

  useEffect(() => {
    setIsLoading(true);
    const currentMasterId =
      location.state?.masterId || (auth.selmasterid ?? auth.masterid);
    const currentAgent = location.state?.currentAgent || auth.username;
    const fromDateStr = location.state?.fromDate;
    const toDateStr = location.state?.toDate;

    setCurrentMasterId(currentMasterId);
    setCurrentAgent(currentAgent);
    if (location.state == null) {
      const formattedFromDate = formatInTimeZone(
        fromDate,
        timeZone,
        "yyyy-MM-dd"
      );
      const formattedToDate = formatInTimeZone(toDate, timeZone, "yyyy-MM-dd");
      const queryParams = {
        action: "companywinlose",
        fromdate: formattedFromDate,
        todate: formattedToDate,
        selmasterid: currentMasterId,
      };
      dispatch(actions.agentDownlineReport(queryParams)).then(() =>
        setIsLoading(false)
      );
    } else {
      const fromDateParsed = new Date(fromDateStr);
      const toDateParsed = new Date(toDateStr);
      setFromDate(fromDateParsed);
      setToDate(toDateParsed);
      setReturnFromDate(fromDateParsed);
      setReturnToDate(toDateParsed);
      const formattedFromDate = formatInTimeZone(
        fromDateParsed,
        timeZone,
        "yyyy-MM-dd"
      );
      const formattedToDate = formatInTimeZone(
        toDateParsed,
        timeZone,
        "yyyy-MM-dd"
      );
      const queryParams = {
        action: "companywinlose",
        fromdate: formattedFromDate,
        todate: formattedToDate,
        selmasterid: currentMasterId,
      };
      dispatch(actions.agentDownlineReport(queryParams)).then(() =>
        setIsLoading(false)
      );
    }
  }, [dispatch]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };
  const handleSearchClick = () => {
    setIsLoading(true);
    const formattedFromDate = formatInTimeZone(
      fromDate,
      timeZone,
      "yyyy-MM-dd"
    );
    const formattedToDate = formatInTimeZone(toDate, timeZone, "yyyy-MM-dd");
    const queryParams = {
      action: "companywinlose",
      fromdate: formattedFromDate,
      todate: formattedToDate,
      selmasterid: currentMasterId,
    };
    dispatch(actions.agentDownlineReport(queryParams)).then((resp) => {
      resp = resp.data;
      setIsLoading(false);
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };
  const handleClick = (masterId, username) => {
    setIsLoading(true);
    setCurrentAgent(username);
    setCurrentMasterId(masterId);
    const formattedFromDate = formatInTimeZone(
      fromDate,
      timeZone,
      "yyyy-MM-dd"
    );
    const formattedToDate = formatInTimeZone(toDate, timeZone, "yyyy-MM-dd");
    const queryParams = {
      action: "companywinlose",
      fromdate: formattedFromDate,
      todate: formattedToDate,
      selmasterid: masterId,
    };
    dispatch(actions.agentDownlineReport(queryParams)).then(() =>
      setIsLoading(false)
    );
  };
  const customCardClass =
    "rounded d-flex align-items-center justify-content-spacebetween py-2";

  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <WinLoseDetails
        detailQuery={detailQuery}
        setDetailQuery={setDetailQuery}
      />
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div>
        <h2>{intl.formatMessage({ id: "agentDownlineReport" })}</h2>
      </div>
      <div>
        <nav>
          <ol className="breadcrumb">
            {reportState.agentDownlineReportLists?.masterUplineList &&
            reportState.agentDownlineReportLists.masterUplineList.length > 0 ? (
              <>
                <li>
                  {reportState.agentDownlineReportLists.masterUplineList
                    .slice()
                    .reverse()
                    .map((agent, index) => (
                      <>
                        <span
                          key={index}
                          onClick={() =>
                            handleClick(agent.masterid, agent.username)
                          }
                        >
                          {index > 0 && " / "}
                          <span style={{ textDecoration: "underline" }}>
                            {agent.username}
                          </span>
                        </span>
                      </>
                    ))}
                </li>
              </>
            ) : (
              <li>
                <span
                  onClick={() => handleClick(auth.selmasterid ?? auth.masterid)}
                >
                  {auth.username}
                </span>
              </li>
            )}
          </ol>
        </nav>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          {location.state === null ? (
            <DateRangeComp
              initialRange={[
                { startDate: fromDate, endDate: toDate, key: "selection" },
              ]}
              onDateChange={handleDateChange}
            />
          ) : (
            <DateRangeComp
              initialRange={[
                {
                  startDate: returnFromDate,
                  endDate: returnToDate,
                  key: "selection",
                },
              ]}
              onDateChange={handleDateChange}
            />
          )}
        </div>
        <div className="d-flex align-items-center">
          {isLoading && (
            <div
              className="spinner-border me-1"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="sr-only"></span>
            </div>
          )}
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>

      <div
        className="member-div"
        style={{
          margin: "10px auto",
        }}
      >
        <div>
          {reportState && reportState.agentDownlineReportLists && (
            <div
              className={`${customCardClass} rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
              style={{
                border: "1px solid grey",
                padding: "5px",
                margin: "10px 0 ",
              }}
            >
              <div style={{ width: "100%" }}>
                <table
                  className="text-start table-report"
                  style={{ width: "100%", minWidth: "600px" }}
                >
                  <tbody>
                    <tr
                      style={{
                        borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                      }}
                    >
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "gateway" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalgateway}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "topup" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totaltopup}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "withdraw" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalwithdraw}
                      </td>
                      <td className="col-3">
                        <span className="fw-bold">
                          {intl.formatMessage({ id: "companyProfit" })}
                        </span>
                        {" : "}
                        <span
                          style={{
                            color:
                              !reportState.agentDownlineReportLists.totalcompanyprofit?.includes(
                                "-"
                              )
                                ? "green"
                                : "red",
                          }}
                        >
                          {
                            reportState.agentDownlineReportLists
                              .totalcompanyprofit
                          }
                        </span>
                      </td>
                    </tr>
                    <tr
                      style={{
                        borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                      }}
                    >
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "refund" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalrefund}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "promotion" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalpromotion}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "marketSpent" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalmarketspent}
                      </td>
                      <td className="col-3">
                        <span className="fw-bold">
                          {intl.formatMessage({ id: "netPurchase" })}
                        </span>
                        {" : "}
                        <span
                          style={{
                            color:
                              !reportState.agentDownlineReportLists.totalnetpurchase?.includes(
                                "-"
                              )
                                ? "green"
                                : "red",
                          }}
                        >
                          {
                            reportState.agentDownlineReportLists
                              .totalnetpurchase
                          }
                        </span>
                      </td>
                    </tr>
                    <tr
                      style={{
                        borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                      }}
                    >
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "gameIn" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalgamein}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "gameOut" }) +
                          " : " +
                          reportState.agentDownlineReportLists.totalgameout}
                      </td>
                      <td className="col-3 td-line" />
                      <td className="col-3">
                        <span className="fw-bold">
                          {intl.formatMessage({ id: "gameProfit" })}
                        </span>
                        {" : "}
                        <span
                          style={{
                            color:
                              !reportState.agentDownlineReportLists.totalgameprofit?.includes(
                                "-"
                              )
                                ? "green"
                                : "red",
                          }}
                        >
                          {reportState.agentDownlineReportLists.totalgameprofit}
                        </span>
                      </td>
                    </tr>
                    {!isMM6MM && (
                      <tr
                        style={{
                          borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                        }}
                      >
                        <td className="col-3 td-line">
                              {intl.formatMessage({ id: "mktBetWin" }) +
                                " : " +
                                reportState.agentDownlineReportLists.totalmktbet}
                              {" / "}
                              {reportState.agentDownlineReportLists.totalmktwin}
                        </td>
                        <td className="col-3 td-line">
                          {intl.formatMessage({ id: "hlBetWin" }) +
                            " : " +
                            reportState.agentDownlineReportLists.totalhlbet}
                          {" / "}
                          {reportState.agentDownlineReportLists.totalhlwin}
                        </td>
                        <td className="col-3 td-line"></td>
                        <td className="col-3"></td>
                      </tr>
                    )}
                    <tr>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "progressiveBet" }) +
                          " : " +
                          reportState.agentDownlineReportLists
                            .totalprogressivebet}
                      </td>
                      <td className="col-3 td-line">
                        {intl.formatMessage({ id: "progressiveWin" }) +
                          " : " +
                          reportState.agentDownlineReportLists
                            .totalprogressivewin}
                      </td>
                      <td className="col-3 td-line"></td>
                      <td className="col-3"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end mb-2">
          <button
            className="btn btn-primary"
            onClick={() => {
              const report = reportState.agentDownlineReportLists
                ?.masterUplineList
                ? reportState.agentDownlineReportLists?.masterUplineList[0]
                : undefined;

              if (report) {
                window.open(
                  `/agentReport/agentDownlineReport/${
                    report.masterid
                  }?currentAgent=${reportState.agentDownlineReportLists?.masterUplineList
                    .slice()
                    .reverse()
                    .map((agent) => agent.username)
                    .join(
                      " / "
                    )}&fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
                  "_blank",
                  "width=800,height=600"
                );
              }
            }}
          >
            {intl.formatMessage({ id: "totalDetails" })}
          </button>
        </div>
        {reportState.agentDownlineReportLists?.companyWinLoses ? (
          reportState.agentDownlineReportLists.companyWinLoses.length > 0 ? (
            reportState.agentDownlineReportLists.companyWinLoses.map(
              (report, index) => (
                <div
                  key={index}
                  className="card mb-3 card-css"
                  style={{ width: "100%" }}
                >
                  <div className="card-body">
                    <div className="row d-flex">
                      <div className="col-12 col-md-3">
                        {report.username?.includes("Personal") ? (
                          <div className="col-12 mb-2">
                            {intl.formatMessage({ id: "username" }) + " : "}
                            <button className="buttonName">
                              {report.username}
                            </button>
                          </div>
                        ) : (
                          <div className="col-12 mb-2">
                            {intl.formatMessage({ id: "username" }) + " : "}
                            <button
                              className="buttonName"
                              onClick={() =>
                                handleClick(report.masterid, report.username)
                              }
                            >
                              {report.username}
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-md-3">
                        {intl.formatMessage({ id: "nickname" }) + " : "}
                        {report.nickname}
                      </div>
                      <div className="col-12 col-md-3"></div>
                      <div className="col-12 col-md-3"></div>
                    </div>
                    <div className="row">
                      <div
                        className="col-12 col-md-3 text-nowrap d-flex justify-content-between align-items-center border"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setDetailQuery({
                            title: intl.formatMessage({ id: "gateway" }),
                            action: "winlose_paymentgatedetail",
                            selmasterid: report.masterid,
                            fromdate: fromDate,
                            todate: toDate,
                          })
                        }
                      >
                        <div className="text-primary">
                          {intl.formatMessage({ id: "gateway" })}
                        </div>
                        <div>{report.gateway}</div>
                      </div>
                      <div
                        className="col-12 col-md-3 d-flex justify-content-between align-items-center border"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setDetailQuery({
                            title: intl.formatMessage({ id: "topup" }),
                            action: "winlose_topupdetail",
                            selmasterid: report.masterid,
                            fromdate: fromDate,
                            todate: toDate,
                          })
                        }
                      >
                        <div className="text-primary">
                          {intl.formatMessage({ id: "topup" })}
                        </div>
                        <div>{report.totaltopup}</div>
                      </div>

                      <div
                        className="col-12 col-md-3 d-flex justify-content-between align-items-center border"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setDetailQuery({
                            title: intl.formatMessage({ id: "withdraw" }),
                            action: "winlose_withdrawdetail",
                            selmasterid: report.masterid,
                            fromdate: fromDate,
                            todate: toDate,
                          })
                        }
                      >
                        <div className="text-primary">
                          {intl.formatMessage({ id: "withdraw" })}
                        </div>
                        <div>{report.totalwithdraw}</div>
                      </div>

                      <div className="col-12 col-md-3  d-flex justify-content-between align-items-center border">
                        <div className="fw-bold">
                          {intl.formatMessage({ id: "companyProfit" })}
                        </div>
                        <div
                          style={{
                            color: !report.companyprofit?.includes("-")
                              ? "green"
                              : "red",
                          }}
                        >
                          {report.companyprofit}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-3  d-flex justify-content-between align-items-center border">
                        <div>{intl.formatMessage({ id: "refund" })}</div>
                        <div>{report.refund}</div>
                      </div>
                      <div className="col-12 col-md-3  d-flex justify-content-between align-items-center border">
                        <div>{intl.formatMessage({ id: "promotion" })}</div>
                        <div>{report.promotion}</div>
                      </div>
                      <div className="col-12 col-md-3  d-flex justify-content-between align-items-center border">
                        <div>{intl.formatMessage({ id: "marketSpent" })}</div>
                        <div>{report.marketspent}</div>
                      </div>
                      <div className="col-12 col-md-3  d-flex justify-content-between align-items-center border">
                        <div className="fw-bold">
                          {intl.formatMessage({ id: "netPurchase" })}
                        </div>
                        <div
                          style={{
                            color: report.netpurchase?.includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {report.netpurchase}
                        </div>
                      </div>
                    </div>
                    <div className="border-top my-2" />
                    <div className="row">
                      <div
                        className="col-12 col-md-3 d-flex justify-content-between align-items-center border"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setDetailQuery({
                            title: intl.formatMessage({ id: "gameIn" }),
                            action: "winlose_gameindetail",
                            selmasterid: report.masterid,
                            fromdate: fromDate,
                            todate: toDate,
                          })
                        }
                      >
                        <div className="text-primary">
                          {intl.formatMessage({ id: "gameIn" })}
                        </div>
                        <div>{report.gamein}</div>
                      </div>
                      <div
                        className="col-12 col-md-3 d-flex justify-content-between align-items-center border"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setDetailQuery({
                            title: intl.formatMessage({ id: "gameOut" }),
                            action: "winlose_gameoutdetail",
                            selmasterid: report.masterid,
                            fromdate: fromDate,
                            todate: toDate,
                          })
                        }
                      >
                        <div className="text-primary">
                          {intl.formatMessage({ id: "gameOut" })}
                        </div>
                        <div>{report.gameout}</div>
                      </div>
                      <div className="col-12 col-md-3" />
                      <div className="col-12 col-md-3 d-flex justify-content-between align-items-center border">
                        <div className="fw-bold">
                          {intl.formatMessage({ id: "gameProfit" })}
                        </div>
                        <div
                          style={{
                            color: report.gameprofit?.includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {report.gameprofit}
                        </div>
                      </div>
                    </div>
                    {!isMM6MM && (
                      <div className="row">
                        <div className="col-12 col-md-3 d-flex justify-content-between align-items-center border">
                          <div>{intl.formatMessage({ id: "mktBetWin" })}</div>
                          <div>
                            {report.mktbet}
                          {" / "}
                          {report.mktwin}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 d-flex justify-content-between align-items-center border">
                        <div>{intl.formatMessage({ id: "hlBetWin" })}</div>
                        <div>
                          {report.hlbet}
                          {" / "}
                          {report.hlwin}
                        </div>
                      </div>
                      <div className="col-12 col-md-3" />
                      <div className="col-12 col-md-3" />
                    </div>
                    )}
                    <div className="row">
                      <div className="col-12 col-md-3 d-flex justify-content-between align-items-center border">
                        <div>
                          {intl.formatMessage({ id: "progressiveBet" })}
                        </div>
                        <div>{report.progressivebet}</div>
                      </div>
                      <div className="col-12 col-md-3 d-flex justify-content-between align-items-center border">
                        <div>
                          {intl.formatMessage({ id: "progressiveWin" })}
                        </div>
                        <div>{report.progressivewin}</div>
                      </div>
                      <div className="col-12 col-md-3" />
                      <div className="col-12 col-md-3" />
                    </div>
                    {index > 0 && (
                      <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              window.open(
                                `/agentReport/agentDownlineReport/${
                                  report.masterid
                                }?currentAgent=${reportState.agentDownlineReportLists?.masterUplineList
                                  .slice()
                                  .reverse()
                                  .map((agent) => agent.username)
                                  .join(" / ")} / ${
                                  report.username
                                }&fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
                                "_blank",
                                "width=800,height=600"
                              );
                            }}
                          >
                            {intl.formatMessage({ id: "details" })}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )
            )
          ) : (
            <div className="card mb-3 card-css" style={{ width: "100%" }}>
              <div className="card-body">
                <div className="row">
                  <div className="no-record-wrapper oRecordDiv">
                    <i className="bi bi-search fs-1 mb-3" />
                    <div className="text-font2">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div class="placeholder-glow rounded">
            <span
              class="placeholder w-100 rounded bg-light"
              style={{ height: "300px" }}
            ></span>
          </div>
        )}
      </div>
    </div>
  );
};
